import styled from 'styled-components'
import colors from '../../../assets/colors'
import { tokens } from '../../../assets/tokens'

// Card del design system de Velora (radio 10 y sombra card); la cabecera usa el color del cliente.
// Sin overflow: hidden para no recortar desplegables que se abren dentro del panel.
const RADIUS = '10px'

export const Container = styled.div`
  margin: 12px 0;
  border-radius: ${RADIUS};
  background-color: ${colors.white};
  box-shadow: ${tokens.shadow.card};
`

export const Content = styled.div`
  padding: 24px;
  background-color: ${colors.white};
  border-radius: ${RADIUS};
`

export const Header = styled.div`
  color: ${colors.white};
  @media print {
    .header-table {
      background: ${props => props.theme.primary}!important;
      -webkit-print-color-adjust: exact;

      p {
        color: ${colors.white}!important;
      }
    }
    .wrap-table {
      background-color: ${colors.white}!important;
    }
  }
  display: flex;
  background: ${props => props.theme.primary};
  border-top-left-radius: ${RADIUS};
  border-top-right-radius: ${RADIUS};
  padding: 12px 24px;

  & + div {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
`

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 100%;
`

export const ContentRight = styled.div``

export const Icon = styled.p`
  path {
    fill: ${props => props.theme.textPrimary};
  }
`

export const Title = styled.p`
  font-weight: 600;
  font-family: ${tokens.typography.fontFamily.primary};
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.03em;
  color: ${props => props.theme.textPrimary};
  margin-bottom: 0;
`
